import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../../handleRequestThunk';
import { getPlacementNoAccountList } from '../placementThunks';
import { commonInitialState } from '../../../../../utils/common/commonInitialState';
const SLICE_NAME = 'placementNoAccountList';

export const placementNoAccountListSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getPlacementNoAccountList });
    },
});

export const placementNoAccountList = placementNoAccountListSlice.reducer;
